module.exports = __webpack_public_path__ + "img/noofuser.98bf6c2e.svg";